import {useQuery} from '@apollo/client';
import {
  ContactVulnerabilities,
  ContactVulnerabilitiesVariables,
} from '../../schema-types/ContactVulnerabilities';
import validateUUID from '../../utils/validateUUID';
import {GET_CONTACT_VULNERABILITIES} from './vulnerabilityQueries';

/**
 * A contact's vulnerabilities. `existing` are the Curo-backed rows Curo still
 * reports as active; `drafts` are rows added in `reviewId` that are not yet in
 * Curo. `curoSync` pulls from Curo before answering.
 */
export const useContactVulnerabilities = (
  contactId: string | undefined,
  {reviewId, curoSync = false}: {reviewId?: string; curoSync?: boolean} = {}
) => {
  const {data, loading, error, refetch} = useQuery<
    ContactVulnerabilities,
    ContactVulnerabilitiesVariables
  >(GET_CONTACT_VULNERABILITIES, {
    variables: {
      contactId: validateUUID(contactId)!,
      reviewId: validateUUID(reviewId),
      curoSync,
    },
    skip: !contactId,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });
  const rows = data?.vulnerabilities ?? [];
  return {
    rows,
    existing: rows.filter((row) => !row.isDraft),
    drafts: rows.filter((row) => row.isDraft),
    loading,
    error,
    refetch,
  };
};
